import classNames from 'classnames';
import React from 'react';
import isEqual from 'react-fast-compare';

import {EvaluatedTable} from 'notebook/tables/excess/Evaluator';
import {Table, table} from 'notebook/tables/TableConstants';
import {
  FinalArrayTypedValue,
  NumberTypedValue,
  ScientificTypedValue,
  StringTypedValue,
} from 'notebook/tables/typed-values/TypedValueTypes';

type HasRawValue = ScientificTypedValue | StringTypedValue | NumberTypedValue | FinalArrayTypedValue;

interface StepTableProps {
  table: Table;
  computedTable: EvaluatedTable;
}

export default class StepTable extends React.Component<StepTableProps> {
  propTypes = {
    table: table.isRequired,
  };

  shouldComponentUpdate(nextProps: StepTableProps): boolean {
    return !isEqual(this.props, nextProps);
  }

  render(): JSX.Element {
    const tableClasses = classNames({
      'header-row': this.props.table.headerRow,
      'header-col': this.props.table.headerCol,
    });

    const renderRows = (rows: EvaluatedTable): Array<JSX.Element> =>
      Array.from(rows).map((row, i) => (
        <tr key={i}>
          {Array.from(row).map((col, j) => (
            <td key={j}>{(col.value as HasRawValue).rawValue}</td>
          ))}
        </tr>
      ));

    return (
      <div className="procedure-table">
        <table className={tableClasses}>
          {this.props.table.headerRow ? (
            <thead>{renderRows(this.props.computedTable.slice(0, 1))}</thead>
          ) : undefined}
          <tbody>
            {this.props.table.headerRow
              ? renderRows(this.props.computedTable.slice(1))
              : renderRows(this.props.computedTable)}
          </tbody>
        </table>
      </div>
    );
  }
}
